import React, { useState } from "react";
import "../../styles/CompanyManagement/CompanyManagement.css";
import { CompanyDetails, CustomerBase, OffersBenefits, Competitors, Integration, KnowledgeBase } from "../../components/CompanyManagement";
import ManageTeam from "../../components/AccountBilling/ManageTeam";
import Subscription from "../../components/AccountBilling/Subscription";
import Billing from "../../components/AccountBilling/Billing";

const Accountbilling = () => {
 const [activeTab, setActiveTab] = useState('company-details');
 const tabs = [
    { id: "Manage-team", label: "Manage team", component: <ManageTeam /> },
    { id: "Subscription", label: "Subscription", component: < Subscription/> },
    { id: "Billing", label: "Billing", component: <Billing /> },
  ];

  return (
    <div className="company-management">
      <h1>Account & Billing</h1>

      <div className="company-management-header">
        <div className="tabs rounded">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab rounded ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-4">
        {tabs.find((tab) => tab.id === activeTab)?.component}
      </div>
    </div>
  );
};

export default Accountbilling;